import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { DefaultFormSelectInput } from "../../../../../../common/components/default_form_select_input";
import { useEffect, useMemo } from "react";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { FornecedorDropDown } from "../../../../../../common/domain/models/fornecedor_dropdown";
import { ReportOrdemComprasLoteForm, ReportOrdemComprasLoteSchema } from "../../../schemas/OrdemCompras_lista/report_ordem_compras_lote";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";

/**
 * ReportOrdemComprasLoteModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  centroCustosDropdown: CentroCustoDropDown[];
  fornecedoresDropdown: FornecedorDropDown[];
  onClose: () => void;
  onSubmit: (form: ReportOrdemComprasLoteForm) => void;
};

export const ReportOrdemComprasLoteModal = ({
  open,
  saving,
  loading,
  centroCustosDropdown,
  fornecedoresDropdown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ReportOrdemComprasLoteForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ReportOrdemComprasLoteSchema),
  });

  const statusOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: 'Todas as ordens de serviço',
      },
      {
        id: 2,
        label: 'Entregue',
      },
      {
        id: 3,
        label: 'Pendente',
      },
      {
        id: 4,
        label: 'Cancelada',
      },
    ];
  }, [
  ]);

  useEffect(() => {
    if (open) {
      hookForm.reset({ status: 1 });
    }
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Ordem Compras Lote"
      confirmButtonLabel="Gerar"
      confirmSavingButtonLabel="Gerando..."
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-4 py-4">
        <DefaultFormAutocomplete
          name='centroCusto'
          label='Centro de Custos'
          options={centroCustosDropdown}
          getOptionKey={x => x.id}
          getOptionLabel={x => x.title}
          reactHookForm={hookForm}
        />

        <DefaultFormSelectInput
          name='status'
          label='Status'
          showSelectionLabel={false}
          options={statusOptions}
          reactHookForm={hookForm}
        />

        <DefaultFormMultiAutocomplete
          name='fornecedores'
          label='Fornecedor'
          options={fornecedoresDropdown}
          getOptionKey={x => x.idFornecedor}
          getOptionLabel={x => x.nomeFantasia}
          reactHookForm={hookForm}
        />

        <FormDatePickerInput
          name='competencia'
          label='Data Competência'
          views={["year", "month"]}
          tipoData="mes"
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
}